import { Component, OnInit, Input, HostListener } from '@angular/core';
import {
  SvcServices,
  windowService
} from '../../services';
import { PopupModalService } from "../../services/popup-modal.service";
import { ContentService } from '../../services';
import { DmarService } from 'app/services/dmar.service';

@Component({
  selector: 'flex-seo',
  templateUrl: './flex-seo.component.html'
})
export class FlexSeoComponent implements OnInit {


  @Input() public primaryMode: boolean;
  @Input() public newCMSContent: boolean;
  @Input() pageData: any;

  applyNowLink: string;
  isAdBlcokerEnabled: any;
  urlParameters: any;
  brandId: string;

  constructor(
    private _svcService: SvcServices,
    private _contentService: ContentService,
    private popupService: PopupModalService,
    public dmarService: DmarService,
    public windowService: windowService
  ) {
  }

  ngOnInit() {
    //this.isAdBlcokerEnabled = this.dmarService.isAdBlockerEnabled();
    if(this.dmarService.isAdBlocking == true){
      this.isAdBlcokerEnabled = true;
    }
    this.addApplyNowLink(this.pageData);

    this.urlParameters = this._contentService.getParams();
    if (this.urlParameters && this.urlParameters.siteId == "PLCN_WFCC") {
      if(!this.urlParameters.brandId) {
        this.brandId='WF';
      } else {
        this.brandId=this.urlParameters.brandId.toUpperCase();
      } 
    }
    console.log('brandId', this.brandId);
  }

  addApplyNowLink(pageData) {
    if (pageData.copy$$signon_flex_seo_subhead && pageData.cmlink$$link_apply_now) {
      pageData.copy$$signon_flex_seo_subhead.TEXT = pageData.copy$$signon_flex_seo_subhead.TEXT.replace('href=\"#\"', 'class="apply-now-link" href="' + pageData.cmlink$$link_apply_now.URL.FULL_URL + '"')
    }

    if (this.isAdBlcokerEnabled && this.dmarService.primaryContentDiffFromFlexSeo()) {
      if (pageData.copy$$signon_primary_banner_subhead && pageData.cmlink$$link_apply_now_primary_banner) {
        pageData.copy$$signon_primary_banner_subhead.TEXT = pageData.copy$$signon_primary_banner_subhead.TEXT.replace('href=\"#\"', 'class="apply-now-link" id ="pbanl" href="' + pageData.cmlink$$link_apply_now_primary_banner.URL.FULL_URL + '"');
      }
    }
  }

  isAdBlockerEnabled() {
    //this.isAdBlcokerEnabled = this.dmarService.isAdBlockerEnabled();
    if(this.dmarService.isAdBlocking == true){
      this.isAdBlcokerEnabled = true;
    }
    return this.isAdBlcokerEnabled;
  }

  //NOTE: unable to add svcSpeedBumpDirective dynamically to an innerHTML link from CMS
  //click event copied from speedBumpDirective
  @HostListener('click', ['$event']) onClick(e) {
    e.preventDefault();
    if (e.target && (e.target.className === "apply-now-link")) {
      this.clickAction(e.target.href);
    }
  }

  clickAction(link) {
    if (/^http/.test(link) && (link.indexOf(this.windowService.nativeWindow.location.origin) < 0) && (link.indexOf("citiretailservices.citibankonline.com") < 0) && (link.indexOf("citicards.citi.com") < 0)) {
      let obj = {};
      let hostRegex = /^(?:https?:\/\/)?(?:www\.)?/i;
      let nonCappedDomainName = window.location.host.toLowerCase().replace(hostRegex, '');
      let InitiCapedDomainName = nonCappedDomainName.charAt(0).toUpperCase() + nonCappedDomainName.slice(1);
      obj["fullHref"] = link;
      obj["host"] = InitiCapedDomainName;
      obj["target"] = '';
      this.popupService.openPopupContent.emit({
        popupContentComponent: "popup-site-redirect",
        popupContentParams: obj
      });
    }
    else {
      this.windowService.nativeWindow.location.href = link;
    }
  }
}
